import { render } from "./examinationBusiness.vue?vue&type=template&id=97331f0c&scoped=true"
import script from "./examinationBusiness.vue?vue&type=script&lang=js"
export * from "./examinationBusiness.vue?vue&type=script&lang=js"

import "./examinationBusiness.vue?vue&type=style&index=0&id=97331f0c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-97331f0c"

export default script